import { inject, observer } from "mobx-react";
import * as React from "react";
class CardRedirect extends React.Component {
  componentDidMount() {
    if (process.env.NODE_ENV !== "test") {
      document.getElementById("card-redirect-form").submit();
    }
  }
  render() {
    const { url, data, method } = this.props.cardStore.paymentRedirect;
    const redirectFrameTarget = this.props.redirectFrameTarget || "_self";
    return /* @__PURE__ */ React.createElement("form", { target: redirectFrameTarget, id: "card-redirect-form", action: url, method }, Object.entries(data).map(([key, value], index) => /* @__PURE__ */ React.createElement("input", { type: "hidden", value, name: key, key: "form-input-" + index })));
  }
}
const CardRedirect$1 = inject("cardStore")(observer(CardRedirect));
export {
  CardRedirect$1 as default
};
